import { fetch } from '@atlassian/eoc-fetch';

import { type MuteResponse, type QuietHoursResponse } from '../../common/types';
import { getTargetAccountIdSuffix } from '../../common/utils';

export const getMuteDetail = (targetAccountId: string | null | undefined): Promise<MuteResponse> =>
	fetch<MuteResponse>(`/v1/users/notifications/mute${getTargetAccountIdSuffix(targetAccountId)}`);

export const getQuietHoursDetail = (
	targetAccountId: string | null | undefined,
): Promise<QuietHoursResponse> =>
	fetch<QuietHoursResponse>(
		`/v1/users/quiet-hours/details${getTargetAccountIdSuffix(targetAccountId)}`,
	);
